import useGet from "api/useGet";
import { FixedBox_btnItem } from "component/app/subItem";
import { DotText } from "component/basic";
import { BtnBox, BtnItem } from "component/basic/btns";
import { comFormat, getDateGap, setDateTime } from "js/function";
import { useNavigate } from "react-router-dom";

function PageContentsSection(data){
    return (
        <div className={`pageContentsSection ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function MypageContentsBox(data){
    return (
        <div className={`mypageContentsBox ${data.addClass||""} ${data.nPadding ? "nPadding" : ""}`}>
            {data.title ? <h2 className={`mypageContents_title`} dangerouslySetInnerHTML={{__html:data.title}}/> : ""}
            {data.children}
            {data.captions && data.captions?.length > 0 ? 
                <div className="mypageContents_captionBox">
                    {data.captions?.map((item,i)=>(
                        <DotText key={i} text={item}/>
                    ))}
                </div>
            :""}
        </div>
    );
}

function MypageControllInfoItem(data){
    return (
        <div className={`mypageControllInfoItem ${data.addClass||""}`}>
            <h2 className={`mypageControllInfoItem_name`} dangerouslySetInnerHTML={{__html:data.name}}/>
            <h3 className={`mypageControllInfoItem_val`} dangerouslySetInnerHTML={{__html:data.val}}/>
        </div> 
    );
}

function MypageControll(data){
    const navigate = useNavigate();

    const mypageApi = useGet({
        url:data?.data ? null : `/mypage`,
        loginType:"login"
    });
    const mypageData = data?.data ? data?.data : mypageApi?.data;

    return (
        <div className={`mypageControll ${data.addClass||""}`}>
            <div className="mypageControllInfo">
                <h1 className={`mypageControllInfo_name`}>{mypageData?.user_name||"고객"} 님</h1>
                <div className="mypageControllInfoItemBox">
                    <MypageControllInfoItem
                        name={"보유 쿠폰"}
                        val={`${comFormat(mypageData?.coupon_count||"0")} 개`}
                    />
                    <MypageControllInfoItem
                        name={"보유 포인트"}
                        val={`${comFormat(mypageData?.total_point||"0")} 포인트`}
                    />
                </div>
                <BtnBox
                    boxType=""
                    addClass={"row2_re mCol2"}
                >
                    <BtnItem
                        addClass="dbColor"
                        contents="로그아웃"
                        func={() => {
                            window.logOut();
                        }}
                    />
                    <BtnItem
                        addClass=""
                        contents={"계정정보 수정"}
                        func={() => {
                            navigate("/mypage/profile")
                        }}
                    />
                </BtnBox>
            </div>
            <div className="mypageMenuBox">
                <FixedBox_btnItem
                    text={"쿠폰 내역"}
                    icon={"/assets/images/icon/mypage_icon_2.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/mypage/coupon")
                    }}
                />
                <FixedBox_btnItem
                    text={"포인트 내역"}
                    icon={"/assets/images/icon/mypage_icon_1.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/mypage/point")
                    }}
                />
                <FixedBox_btnItem
                    text={"알림"}
                    icon={"/assets/images/icon/mypage_icon_0.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/alarm")
                    }}
                />
                <FixedBox_btnItem
                    text={"설정"}
                    icon={"/assets/images/icon/mypage_icon_5.svg"}
                    addClass=""
                    func={()=>{
                        navigate("/mypage/setting")
                    }}
                />
            </div>
        </div>
    );
}

function MypageIcon(data){
    return (
        <div className="mypage_icon">
            <img src={`/assets/images/icon/${data.icon}.svg`}/>
        </div>
    );
}

function AlarmListContents(data){
    return (
        <>
            <div className="alarmListItem_info">
                <MypageIcon icon={"alarm_icon"}/>
                <div className="alarmListItem_textBox">
                    <h2 className={`alarmListItem_title`} dangerouslySetInnerHTML={{__html:data.title}}/>
                    {data.contents ? <h3 className={`alarmListItem_text`} dangerouslySetInnerHTML={{__html:data.contents}}/> : ""}
                </div>
            </div>
            <img src="/assets/images/icon/mypage_move.svg"/>
        </>
    );
}

function AlarmList(data){
    return (
        <>
        {data.link ? 
            <a target="_blank" href={data.link} className={`alarmListItem ${data.addClass||""} ${data.status == 1 ? "active" : ""}`}>
                <AlarmListContents
                    title={data.title}
                    contents={data.contents}
                />
            </a>
            :
            <div className={`alarmListItem ${data.addClass||""} ${data.status == 1 ? "active" : ""}`}>
                <AlarmListContents
                    title={data.title}
                    contents={data.contents}
                />
            </div>
        }
        </>
    );
}

function MypageCountBox(data){
    return (
        <PageContentsSection addClass="mypageCountBox">
            <MypageContentsBox
                nPadding={false}
                title={null}
            >
                <div className="mypageCount_info">
                    <div className="mypageCount_nameBox">
                        <MypageIcon icon={data.type === "point" ? "point" : "coupon"}/>
                        <h1 className={`mypageCount_title`} dangerouslySetInnerHTML={{__html:data.title}}/>
                    </div>
                    <p className={`mypageCount_val`} dangerouslySetInnerHTML={{__html:`<span class='wbTextColor'>${data.val}</span>${data.unit ? ` ${data.unit}` : ""}`}}/>
                </div>
                {data.type === "coupon" ? 
                <BtnItem
                    addClass="subColor"
                    contents={"쿠폰 등록"}
                    func={() => {
                        data.func()
                    }}
                />
                :""}
            </MypageContentsBox>
        </PageContentsSection>
    );
}

function MypageBasicListItem(data){
    let newDate = new Date();
    let now = setDateTime(newDate,"yymmddhhtt","hymd");
    let gapDate = data.end_date ? getDateGap(now,data.end_date,"day",true) : null

    return (
        <div className={`mypageBasicListItem ${data.status == 1 || (gapDate < 0) ? "active" : ""}`}>
            <div className={`mypageBasicListItemBox ${data.type === "coupon" ? "mypageCouponListItemBox" : ""}`}>
                <div className="mypageBasicListItem_leftInfo">
                    {data.coupon_type == 2 ? <div className={`mypageBasicListItem_leftInfoImg backgroundImg pcItemT ${data.addClass||""}`} style={{backgroundImage:`url('${data.image_url}')`}}/> : ""}
                    <div className="mypageBasicListItem_titleBox">
                        <h1 className={`mypageBasicListItem_title`}>
                            {data.type === "coupon" ? 
                                <>
                                <span className={"wbTextColor"}>{data.coupon_type == 2 ? "제휴사 쿠폰" : `${comFormat(data.discount_value||"0")}${data.discount_type === "price" ? "원" : "%"}`}</span>
                                {(data.coupon_type == 2 ? data.company_name : data.name)||"-"}
                                </>
                            : <><span className={data.pointType == 1 ? "wbTextColor" : "rTextColor"}>{data.pointType == 1 ? "적립" : "차감"}</span> {data.contents}</>}
                        </h1>
                        <h2 className={`mypageBasicListItem_subTitle`}>
                            {data.type === "coupon" ? 
                                <div className="coupon_subInfo">
                                    {data.coupon_type == 2 ? data.name||"-" : (data.use_condition === 'max_price' ? `최대 ${comFormat(data.use_condition_value||"0")}원 할인` : (data.use_condition === 'min_price' ? `주문 금액 ${comFormat(data.use_condition_value||"0")}원 이상` : ''))}
                                    <h1 className={`mypageCouponCount mItemT`}>
                                        {data.status == 0 && (gapDate < 0) ? 
                                            "기간 만료"
                                        : data.status == 0 ? 
                                            data.end_date ? 
                                                <><span className={"rTextColor"}>D-{comFormat(gapDate||"0")}</span> 남음</>
                                                : "제한 없음"
                                        : data.status == 1 ? 
                                            "사용 완료"
                                        : ""}
                                    </h1>
                                </div>
                            : <>{data.created_at ? setDateTime(data.created_at,"yymmdd","hymd") : "-"}</>}
                        </h2>
                    </div>
                </div>
                {data.type === "coupon" ? 
                    <div className="mypageCouponItemBox pcItemT">
                        <h1 className={`mypageCouponCount`}>
                            {data.status == 0 && (gapDate < 0) ? 
                                "기간 만료"
                            : data.status == 0 ? 
                                data.end_date ? 
                                    <><span className={"rTextColor"}>D-{comFormat(gapDate||"0")}</span> 남음</>
                                    : "제한 없음"
                            : data.status == 1 ? 
                                "사용 완료"
                            : ""}
                        </h1>
                        {data.coupon_type == 2 && data.status == 0 && (gapDate >= 0) ? 
                            <BtnItem
                                addClass="line"
                                contents={"쿠폰 사용"}
                                func={() => {
                                    data.func()
                                }}
                            />
                        :""}
                    </div>
                :
                    <div className="mypagePointItemBox">
                        <h1 className={`mypagePointCount`}><span className={data.pointType == 1 ? "wbTextColor" : "rTextColor"}>{data.pointType == 1 ? "" : "- "}{comFormat(data.point||"0")}</span> 포인트</h1>
                        <h2 className={`mypagePointRemainCount`}>잔여 포인트 {comFormat(data.remain_point||"0")} 포인트</h2>
                    </div>
                }
            </div>
            {data.coupon_type == 2 && data.status == 0 && (gapDate >= 0) ? 
                <BtnItem
                    addClass="line mItemT"
                    contents={"쿠폰 사용"}
                    func={() => {
                        data.func()
                    }}
                />
            :""}
        </div>
    );
}

function PopupBasicCaption(data){
    return (
        <p className="popupBasicCaption" dangerouslySetInnerHTML={{__html:data.text}}/>
    );
}

function MypageSetItemTitleBox(data){
    return (
        <div className={`mypageSetItemTitleBox ${data.addClass||""}`}>
            <h2 className={`mypageSetItemTitle`} dangerouslySetInnerHTML={{__html:data.title}}/>
            {data.subTitle ? <h3 className={`mypageSetItemSubTitle`} dangerouslySetInnerHTML={{__html:data.subTitle}}/> : ""}
        </div> 
    );
}

function MypageSetItemArea(data){
    return (
        <div className={`mypageSetItemArea ${data.addClass||""}`}>
            {data.children}
        </div> 
    );
}

function MypageSetItemSubArea(data){
    return (
        <div className={`mypageSetItemSubArea ${data.addClass||""}`}>
            {data.children}
        </div> 
    );
}

function MypageSetItem(data){
    return (
        <div className={`mypageSetItem ${data.addClass||""} ${data.func ? "mypageSetBtnItem" : ""}`} onClick={()=>{if(data.func)data.func()}}>
            <MypageSetItemTitleBox
                title={data.title}
                subTitle={data.subTitle}
            />
            {data.children ? 
            data.children
            : <img src="/assets/images/icon/mypage_move.svg"/>}
        </div> 
    );
}

function MypageSnsItem(data){
    function snsIcon(name){
        let icon = "";

        if(name === "네이버"){
            icon = "naver"
        }else if(name === "카카오톡"){
            icon = "kakao"
        }else if(name === "구글"){
            icon = "google"
        }else if(name === "애플"){
            icon = "apple"
        }

        return icon;
    }

    return (
        <div className={`mypageSnsItem ${data.addClass||""} ${data.status == 0 ? "mypageSnsBtnItem" : ""}`} onClick={()=>{if(data.status == 0){data.func()}}}>
            <div className="mypageSns_infoItem">
                <img src={`/assets/images/sns/${snsIcon(data.name)}.svg`}/>
                <p className="mypageSns_infoName" dangerouslySetInnerHTML={{__html:data.name}}/>
            </div>
            <div className={`mypageSns_statusBox ${data.status == 1 ? "interlock_statusBox" : ""}`}>
                <p className={`mypageSns_status ${data.status == 1 ? "wbTextColor" : ""}`}>{data.status == 1 ? "연동완료" : "연동하기"}</p>
                <img src="/assets/images/icon/mypage_move.svg"/>
            </div>
        </div> 
    );
}

export {PageContentsSection,MypageControll,MypageContentsBox,AlarmList,MypageCountBox,MypageBasicListItem,PopupBasicCaption,MypageSetItemArea,MypageSetItemSubArea,MypageSetItem,MypageSnsItem}